import { Commented } from '../commented'
import type { Expression } from '../expression'
import * as fn from '../fn'
import * as instance from '../instance'
import * as primitive from '../primitive'

import type { Context } from './context'
import type { Node } from './node'

export function from<T>(expression: Expression<T>, context: Context): Node<T> {
  // NOTE: this is a faster TypeChecker than Fn.isFn
  if (primitive.Primitive.isPrimitive(expression)) {
    // NOTE: TypeScript doesn't realize `expression` is both T and a Primitive
    return primitive.node.from(expression as Extract<T, primitive.Primitive>)
  }
  if (Commented.isCommented(expression)) {
    return from(Commented.getExpressionWithoutComment(expression), context)
  }
  // NOTE: this is a faster TypeChecker than Fn.isFn
  if (instance.Instance.isInstance(expression)) {
    return instance.node.from(expression, context)
  }

  return fn.node.from(expression, context)
}
